import { render } from "./DynamicContentRule.vue?vue&type=template&id=8c85b160"
import script from "./DynamicContentRule.vue?vue&type=script&lang=js"
export * from "./DynamicContentRule.vue?vue&type=script&lang=js"

import "./DynamicContentRule.vue?vue&type=style&index=0&id=8c85b160&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__